






















































import { Component } from "vue-property-decorator";
import BasePage from "@/views/base/BasePage";
import { NullableString } from "@/code/Types";
import { accountStore } from "@/store/modules/AccountStore";
import { Routes } from "@/router/Routes";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import { OpportunityData } from "@/models/OpportunityData";

@Component
export default class extends BasePage {
  get allBusinessCases(): OpportunityData[] {
    return opportunityStore.entities;
  }

  search: NullableString = null;
  headers = [
    { text: "Client Name", value: "clientFullName" },
    { text: "Line Of Business", value: "opportunityProductLine" },
    { text: "Status", value: "status" },
    { text: "Carrier", value: "insurance" },
    { text: "Policy Number", value: "policyNumber" },
    { text: "Last Updated", value: "modifiedOn" },
    { text: "FA", value: "agentFullName" },
  ];
  get agentFullName(): NullableString | undefined {
    return accountStore.user?.agentFullName;
  }

  async selectClient(id: string): Promise<void> {
    await this.$router.push({
      name: Routes.NEW_BUSINESS_CASE_DETAIL,
      params: { id },
    });
  }
}
